import React, { useEffect, useState } from 'react';
import { Table, Form, Badge, Pagination, Spinner, Card } from 'react-bootstrap';
import { FaUser, FaClock } from 'react-icons/fa';
import { auditAPI } from '../services/api';
import { toast } from 'react-toastify';

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => { fetchLogs(); }, [page, search, filter]);

  const fetchLogs = async () => {
    try {
      const response = await auditAPI.getLogs({ page, search, action: filter !== 'all' ? filter : undefined });
      setLogs(response.data.data);
      setTotalPages(response.data.pagination.pages);
    } catch (error) { toast.error('Failed to load audit logs'); }
    finally { setLoading(false); }
  };

  const getActionBadge = (action) => {
    const colors = { login_success: 'success', login_failed: 'danger', user_created: 'primary', license_created: 'info', device_reset: 'warning', credits_added: 'success', credits_removed: 'danger' };
    return <Badge bg={colors[action] || 'secondary'}>{action}</Badge>;
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3><FaUser /> Audit Logs</h3>
        <Form.Select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ width: '200px' }}>
          <option value="all">All Actions</option>
          <option value="login_success">Successful Logins</option>
          <option value="login_failed">Failed Logins</option>
          <option value="user_created">User Created</option>
          <option value="device_reset">Device Reset</option>
          <option value="credits_added">Credits Added</option>
        </Form.Select>
      </div>

      <Form.Control type="text" placeholder="Search logs..." value={search} onChange={(e) => setSearch(e.target.value)} className="mb-3" />

      <Card>
        <Card.Body>
          <Table striped bordered hover responsive size="sm">
            <thead>
              <tr><th>Time</th><th>User</th><th>Action</th><th>Entity</th><th>IP Address</th></tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td><FaClock className="me-1" />{new Date(log.created_at).toLocaleString()}</td>
                  <td>{log.user?.name || 'System'}</td>
                  <td>{getActionBadge(log.action)}</td>
                  <td>{log.entity_type ? `${log.entity_type} #${log.entity_id}` : '-'}</td>
                  <td><code>{log.ip_address}</code></td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Pagination className="mt-3">{[...Array(totalPages)].map((_, i) => (
        <Pagination.Item key={i + 1} active={i + 1 === page} onClick={() => setPage(i + 1)}>{i + 1}</Pagination.Item>
      ))}</Pagination>
    </div>
  );
};

export default AuditLogs;
